import { COGNISM_BYOT, useVariableValue } from "lib/featureFlags";
import { useUnifiedContacts } from "lib/hooks/useUnifiedContacts";

/**
 * Whether the user gets bring-your-own-token: the Cognism token settings page, where a company
 * admin swaps Stotles' token for their company's own and bills Cognism usage to their account.
 *
 * Sits inside the unified contacts experience and is narrower than it. Both have to be on:
 * - `useUnifiedContacts`, the gate on the experience as a whole.
 * - the `cognism-byot` flag, so a company that has the experience is not offered its own token
 *   until we have agreed to it with them.
 *
 * Being allowed to see contact data at all remains the CONTACTS data type, and managing the token
 * remains company-admin only; both are checked at the call sites.
 */
export function useCognismByot(): boolean {
  const isUnifiedContactsEnabled = useUnifiedContacts();
  // Coerced: the e2e flag mock returns undefined rather than the declared boolean.
  const flagEnabled = useVariableValue(COGNISM_BYOT, false) === true;

  return isUnifiedContactsEnabled && flagEnabled;
}
